import React from 'react';
//select
import SelectSearch from 'react-select-search';
import 'src/asset/scss/plugin/select.scss';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/styles/userPartnerCalcList.module.scss';
//compWrapper
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트//div

export default function Search(props) {
    //searchData
    const searchRef = props.search;
    //selectOption
    const option1 = [{name:'전체', value:'ALL'}, {name:'상호명', value:'1'}];
    //냘짜셋팅
    const today = new Date().toISOString().slice(0, 10);//오늘날짜셋팅
    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1).toISOString().slice(0, 10);//이번달첫날
    /* ==================== 검색이벤트 ==================== */
    const handleKeydown = (e) => {
        if(e.key === 'Enter') {
            props.onSearch(1);
        }
    };
    const onChangeHandler = (e) => {
        const value = e.target.value;
        if(value.length > 0) { return; }
        props.onSearch(1);
    }
    /* ==================== 검색이벤트 ==================== */

    return ( 
        <Element tag={`div`} className={styles.searchArea}>
            <Element tag={`div`}  className="selectArea">
                <SelectSearch options={option1} defaultValue={searchRef?.current[0]?.value === undefined ? option1[0].value : searchRef?.current[0]?.value}
                    ref={el => (searchRef.current[0] = el)} onChange={el => { (searchRef.current[0].value = el) }}
                    placeholder="상호명" />
            </Element>
            <Element tag={`div`} className={styles.searchField}>
                <input ref={el => (searchRef.current[1] = el)} onKeyDown={(e) => handleKeydown(e)} onChange={(e) => onChangeHandler(e)}
                    type="text" placeholder="업체를 검색 해보세요" />
                <button><FontAwesomeIcon icon="fa-light fa-magnifying-glass" /></button>
            </Element>
            <Element tag={`div`} className={styles.dateField}>
                <input type="date" onChange={(e) => props.onSearch(1)}
                    ref={el => (searchRef.current[2] = el)}
                    defaultValue={firstDay} />
                <Element tag={`span`}>-</Element>
                <input type="date" onChange={(e) => props.onSearch(1)} 
                    ref={el => (searchRef.current[3] = el)}
                    defaultValue={today} />
            </Element>
        </Element>
    );
}